import { query } from '@confluence/query-preloader-tools';

import { LegacyBridgeQuery } from '../graphql/LegacyBridgeQuery.graphql';
import type {
	LegacyBridgeQuery as LegacyBridgeQueryType,
	LegacyBridgeQueryVariables,
} from '../__types__/LegacyBridgeQuery';

export async function preloadLegacyBridge({
	contentId,
	isBlog,
}: {
	contentId: string;
	isBlog: boolean;
}) {
	if (!contentId) {
		return;
	}

	return query<LegacyBridgeQueryType, LegacyBridgeQueryVariables>({
		query: LegacyBridgeQuery,
		variables: { contentId, isBlog },
		errorPolicy: 'all',
	});
}
